import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busLaiXeApi } from "../../../api/bus/busLaiXeApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eBusLaiXeActionTypeIds, IBusLaiXeDeleteStart, IBusLaiXeSaveStart } from "../../action-types/bus/IBusLaiXeActionTypes";
import { busLaiXeActions } from "../../actions/bus/busLaiXeActions";

export function* busLaiXeSaga(): any {
	yield takeLatest(eBusLaiXeActionTypeIds.LOAD_START, loadBusLaiXeWorker)
	yield takeEvery(eBusLaiXeActionTypeIds.DELETE_START, deleteBusLaiXeWorker)
	yield takeEvery(eBusLaiXeActionTypeIds.SAVE_START, saveBusLaiXeWorker)
}

function* loadBusLaiXeWorker(): any {
	const res: IBaseResponeModel = yield call([busLaiXeApi, busLaiXeApi.SelectAll])
	if (res.is_success) {
		yield put(busLaiXeActions.loadBusLaiXeSuccess(res.data || []))
	} else {
		yield put(busLaiXeActions.loadBusLaiXeError(res.message || "Không tải được danh sách lái xe bus"))
	}
}

function* deleteBusLaiXeWorker(action: IBusLaiXeDeleteStart): any {
	const res: IBaseResponeModel = yield call([busLaiXeApi, busLaiXeApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busLaiXeActions.deleteBusLaiXeSuccess())
	} else {
		yield put(busLaiXeActions.deleteBusLaiXeErr(res.message || "Không xoá được lái xe bus"))
	}
}

function* saveBusLaiXeWorker(action: IBusLaiXeSaveStart): any {
	let res: IBaseResponeModel;
	if (action.payload.id > 0) {
		res = yield call([busLaiXeApi, busLaiXeApi.Update], action.payload);
	} else {
		res = yield call([busLaiXeApi, busLaiXeApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busLaiXeActions.saveBusLaiXeSuccess())
	} else {
		yield put(busLaiXeActions.saveBusLaiXeError(res.message || "Không lưu được lái xe bus"))
	}
}
